import { AlertTriangle } from 'lucide-react';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';

export const DegradedServiceBanner = () => {
  const { degradedServiceBannerMessage } = useLaunchDarkly();

  const message = degradedServiceBannerMessage?.trim() || '';

  if (!message) {
    return null;
  }

  return (
    <div className='flex items-center justify-center gap-2.5 bg-red-100 dark:bg-red-950/40 px-4 py-2 border-b border-red-300 dark:border-red-800'>
      <AlertTriangle className='size-4 shrink-0 text-red-700 dark:text-red-500' />
      <span className='font-semibold text-sm text-red-900 dark:text-red-300'>
        {message}
      </span>
    </div>
  );
};
